export default __webpack_public_path__ + "static/media/MS.a9c48cc0.svg";